<template>
    <nav
        v-click-outside="closeAll"
        :class="{
            [`theme-${layout.theme}`]: true,
        }"
    >
        <DSHorizontalList
            tag="ul"
            class="list"
            :items="computedLinks"
        />
    </nav>
</template>
<script setup>
import { ref, computed, watch, inject, useRoute, useNuxtApp } from '#imports';
import vClickOutside from '~dsc/directives/click-outside';
const route = useRoute();
const layout = inject('layout');
const openItem = ref('');
const mobileOpen = ref(false);
const { $cms } = useNuxtApp();

const props = defineProps({
    id: {
        type: String,
        required: false,
        default: null,
    },
    links: {
        type: Array,
        required: false,
        default: () => [],
    },
});

defineEmits([ 'select' ]);

const computedLinks = computed(() => props.links
    .filter(link => {
        if (link.visibleInNavigation || link.visibleInNavigation === undefined) return link;

        return false;
    })
    .map(link => ({
            id: link.id,
            url: $cms.localizeLink(link.url),
            text: link.text,
            active: link.active,
        }
    )));

const closeAll = () => {
    if (!props.id) {
        openItem.value = '';
    }
};

watch(() => route.path, () => {
    openItem.value = '';
    mobileOpen.value = false;
});
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';

nav {
    display: inline-flex;
    position: relative;
    flex-flow: row nowrap;
    justify-content: start;
    pointer-events: none;

    @include respond-to('at most small desktop') {
        flex-flow: column wrap;
    }

    &.theme-black {
        * {
            color: var(--color-base-white);
        }

        .item {
            &.selected {
                color: var(--color-secondary-500);
            }

            &.open {
                button {
                    .icon {
                        color: var(--color-secondary-500);
                    }
                }
            }
        }
    }

    * {
        pointer-events: auto;
    }

    :deep(.list) {
        display: flex;
        align-items: center;
        width: 100%;
        min-height: 1.5rem;
        align-self: center;

        .item.item {
            display: inline-flex;
            white-space: nowrap;
            margin-right: 0;
        }
    }
}
</style>
